// @flow

import * as React from 'react';

import Toolbar from './Components/Toolbar';
import Table from './Components/Table';

type Props = {
  searchTerm: string,
  project: {},
  fetching: Boolean,

  componentWillMount: Function,
  onChangeSearch: Function,
}

export default class extends React.PureComponent<Props> {

  componentWillMount = () => this.props.componentWillMount()

  render() {
    const {
      searchTerm,
      project,
      fetching,
      onChangeSearch,
    } = this.props;

    return (
      <React.Fragment>

        <Toolbar
          searchTerm={searchTerm}
          onChangeSearch={onChangeSearch}
        />

        <Table
          project={project}
          fetching={fetching}
        />

      </React.Fragment>
    )
  }
}
